import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { ViewState } from "../../../common/config/AppConstants";
import * as format from "../../../common/FormatFunctions";
import { ListValueDisplay } from "../../Common/ListValueDisplay";

export class BuildingDisplay extends React.Component {
  render() {
    var bean = this.props.data;
    if (!format.isNotNull(bean)) {
      return <div></div>;
    }
    return (
      <div>
        <div
          className="ui-g-12 card-round"
          onClick={e => {
            if (format.isFunction(this.props.onClick)) {
              this.props.onClick(bean);
            }
          }}
        >
          <div className="ui-g-12">
            <div className="ui-g-4">
              <b>Building Name: </b>
              <label>{bean.name || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>Address Line 1: </b>
              <label>{bean.addressLine1 || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>Address Line 2: </b>
              <label>{bean.addressLine2 || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-4">
              <b>Postcode: </b>
              <label>{bean.postcode || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>City: </b>
              <label>{bean.town || "Not Set"}</label>
            </div>
            <div className="ui-g-4">
              <b>Email: </b>
              <label>{bean.email || "Not Set"}</label>
            </div>
          </div>
          <div className="ui-g-12">
            <div className="ui-g-4">
              <b>Contact Telephone: </b>
              <label>{bean.telephone || "Not Set"}</label>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Sites/UI/BuildingDisplay.js